export const ehLevels = ["EH2+", "EH3"];

export const subscriptionTerms = [
  { value: "ONE_YEAR", label: "Eenjarig abonnement" },
  { value: "THREE_YEARS", label: "Driejarig abonnement" },
];

export const defaultSubscriptionTerm = subscriptionTerms[0].value;

export function subscriptionTermLabel(value) {
  const term = subscriptionTerms.find((term) => term.value === value);
  return term ? term.label : "";
}

export const secondFactors = ["SMS", "OTP"];

export const idTypes = ["Identiteitskaart", "Paspoort", "Rijbewijs"];
